src/app.vue
<template>
  <div :class="[_.app, isTV && _.tv, '__app__', hasTabbar && '__has_tabbar__']">
    <!-- 页面渲染 -->
    <navigation><router-view /></navigation>

    <!-- Tab 栏 -->
    <div v-if="hasTabbar" :class="[_.tabbar, '__tabbar__']">
      <div
        v-track="{
          name: '底部导航栏-优选',
        }"
        :class="[_.item, currentPageName === 'HomeIndex' && _.current]"
        @click="redirectTo('HomeIndex')"
      >
        <img
          :class="_.icon"
          :src="
            currentPageName === 'HomeIndex'
              ? $globalModel.state.homeTabCanBackTop
                ? require('./images/tab_bar/回顶.png')
                : require('./images/tab_bar_2023/首页_选中.png')
              : require('./images/tab_bar_2023/首页.png')
          "
        />

        <div :class="_.label">
          {{
            currentPageName === 'HomeIndex' &&
            $globalModel.state.homeTabCanBackTop
              ? '回到顶部'
              : '首页'
          }}
        </div>
      </div>

      <div
        v-if="false"
        v-track="{
          name: '底部导航栏-黔货出山',
        }"
        :class="[_.item, currentPageName === 'DiyFixedQhcs' && _.current]"
        @click="redirectTo('DiyFixedQhcs')"
      >
        <img
          :class="_.icon"
          :src="
            currentPageName === 'DiyFixedQhcs'
              ? require('./images/tab_bar_2023/黔货出山_选中.png')
              : require('./images/tab_bar_2023/黔货出山.png')
          "
        />
        <div :class="_.label">黔货出山</div>
      </div>
      <div
        v-track="{
          name: '底部导航栏-购物车',
        }"
        :class="[_.item, currentPageName === 'CartIndex' && _.current]"
        @click="redirectTo('CartIndex')"
      >
        <img
          :class="_.icon"
          :src="
            currentPageName === 'CartIndex'
              ? require('./images/tab_bar_2023/购物车_选中.png')
              : require('./images/tab_bar_2023/购物车.png')
          "
        />
        <div :class="_.label">购物车</div>
      </div>
      <div
        v-track="{
          name: '底部导航栏-我的',
        }"
        :class="[_.item, currentPageName === 'UserIndex' && _.current]"
        @click="redirectTo('UserIndex')"
      >
        <img
          :class="_.icon"
          :src="
            currentPageName === 'UserIndex'
              ? require('./images/tab_bar_2023/我的_选中.png')
              : require('./images/tab_bar_2023/我的.png')
          "
        />
        <div :class="_.label">我的</div>
      </div>
    </div>
    <x-leave-dialog
      v-model="$state.leaveDialogVisible"
      :message="$state.leaveDialogMessage"
      :url="$state.leaveDialogUrl"
    />
    <x-login-dialog
      v-model="$state.loginDialogVisible"
      @success="handleLoginSuccess"
      @cancel="handleLoginCancel"
    />

    <van-popup
      v-model="$globalModel.state.shareGuideVisible"
      position="top"
      :class="_.shareGuide"
    >
      <div :class="_.text">
        {{ $globalModel.state.shareGuideText }}
      </div>
    </van-popup>

    <Port />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { globalModel } from './model'
  import { pageNameMap, redirectTo } from '@/router'
  import { Port } from '@/port'

  export default Vue.extend({
    components: {
      Port,
    },

    mixins: [globalModel.mixin],

    data: () => ({
      // 加载状态
      loading: true,
    }),

    computed: {
      isTV() {
        return globalModel.state.isTV
      },

      // 当前页面名称
      currentPageName() {
        return this.$route.name
      },

      // 当前页面是否有 Tab 栏
      hasTabbar() {
        return (
          globalModel.state.channelIsShowTab &&
          !globalModel.state.isChinaMall &&
          !globalModel.state.isEmbed &&
          !globalModel.state.isPure &&
          ['HomeIndex', 'DiyFixedQhcs', 'CartIndex', 'UserIndex'].includes(
            this.currentPageName,
          )
        )
      },
    },

    methods: {
      // 跳转
      redirectTo(pageName) {
        if (
          pageName === pageNameMap.HomeIndex &&
          this.currentPageName === pageNameMap.HomeIndex &&
          globalModel.state.homeTabCanBackTop
        ) {
          document.querySelector('.__page_container__')?.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        } else {
          redirectTo(pageName)
        }
      },

      handleLoginSuccess(p) {
        globalModel.state.loginDialogSuccessCallbacks.forEach(cb => cb(p))
        globalModel.update({
          loginDialogSuccessCallbacks: [],
          loginDialogCancelCallbacks: [],
        })
      },

      handleLoginCancel() {
        globalModel.state.loginDialogCancelCallbacks.forEach(cb => cb())
        globalModel.update({
          loginDialogSuccessCallbacks: [],
          loginDialogCancelCallbacks: [],
        })
      },
    },
  })
</script>

<style lang="scss" module>
  * {
    padding: 0;
    margin: 0;
    word-break: break-all;
    -webkit-tap-highlight-color: transparent;
  }

  :global {
    .van-multi-ellipsis--l1 {
      display: -webkit-box !important;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    #__vconsole {
      *[focused]:not(.vc-content) {
        background-color: #ff5722 !important;
        color: white !important;
        font-weight: bold !important;
      }

      *[focused].vc-content {
        border: 2px solid #ff5722;
      }
    }
  }

  .app {
    &:not(.tv) {
      @media only screen and (min-width: 500px) {
        max-width: 500px;
        margin: auto;
        transform: scale(1);
        box-shadow: 0 0 8px rgb(155 145 145 / 24%);
      }
    }
  }

  .shareGuide {
    top: var(--page-header-height);
    right: 0;
    left: auto;
    width: 189px;
    height: 185px;
    background-color: transparent;
    background-image: url('./images/分享指引.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .text {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 140px;
      height: 80px;
      padding: 0 24px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: var(--bold-value);
      color: #ffffff;
      line-height: 22px;
    }
  }

  .tabbar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #ffffff;
    display: flex;
    align-items: center;
    user-select: none;
    line-height: 1;
    font-size: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: content-box;
    user-select: none;

    .item {
      flex: 1;
      text-align: center;

      .icon {
        width: 24px;
        height: 24px;
        object-fit: cover;
        pointer-events: none;
      }

      .label {
        margin-top: 5px;
        font-size: 10px;
        color: #888888;
      }

      &.current {
        .label {
          color: #ff111c;
        }
      }

      &.special {
        &.current {
          .icon {
            width: 37px;
            height: 37px;
          }

          .label {
            display: none;
          }
        }
      }
    }
  }

  // https://fonts2u.com/bebas-regular.font
  @font-face {
    font-family: 'Bebas-Regular';
    src: url(data:application/font-woff;base64,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)
      format('woff');
    font-weight: normal;
    font-style: normal;
  }
</style>

<style>
  /* node_modules/quill/dist/quill.core.css */
  /*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
  .ql-container {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    height: 100%;
    margin: 0px;
    position: relative;
  }
  .ql-container.ql-disabled .ql-tooltip {
    visibility: hidden;
  }
  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
    pointer-events: none;
  }
  .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }
  .ql-clipboard p {
    margin: 0;
    padding: 0;
  }
  .ql-editor {
    /* box-sizing: border-box; */
    line-height: 1.42;
    /* height: 100%; */
    /* outline: none; */
    /* overflow-y: auto; */
    /* padding: 12px 15px; */
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .ql-editor > * {
    cursor: text;
  }
  .ql-editor p,
  .ql-editor ol,
  .ql-editor ul,
  .ql-editor pre,
  .ql-editor blockquote,
  .ql-editor h1,
  .ql-editor h2,
  .ql-editor h3,
  .ql-editor h4,
  .ql-editor h5,
  .ql-editor h6 {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
  }
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em;
  }
  .ql-editor ol > li,
  .ql-editor ul > li {
    list-style-type: none;
  }
  .ql-editor ul > li::before {
    content: '\2022';
  }
  .ql-editor ul[data-checked='true'],
  .ql-editor ul[data-checked='false'] {
    pointer-events: none;
  }
  .ql-editor ul[data-checked='true'] > li *,
  .ql-editor ul[data-checked='false'] > li * {
    pointer-events: all;
  }
  .ql-editor ul[data-checked='true'] > li::before,
  .ql-editor ul[data-checked='false'] > li::before {
    color: #777;
    cursor: pointer;
    pointer-events: all;
  }
  .ql-editor ul[data-checked='true'] > li::before {
    content: '\2611';
  }
  .ql-editor ul[data-checked='false'] > li::before {
    content: '\2610';
  }
  .ql-editor li::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  .ql-editor li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }
  .ql-editor li.ql-direction-rtl::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
  }
  .ql-editor ol li:not(.ql-direction-rtl),
  .ql-editor ul li:not(.ql-direction-rtl) {
    padding-left: 1.5em;
  }
  .ql-editor ol li.ql-direction-rtl,
  .ql-editor ul li.ql-direction-rtl {
    padding-right: 1.5em;
  }
  .ql-editor ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
    counter-increment: list-0;
  }
  .ql-editor ol li:before {
    content: counter(list-0, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-increment: list-1;
  }
  .ql-editor ol li.ql-indent-1:before {
    content: counter(list-1, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-2 {
    counter-increment: list-2;
  }
  .ql-editor ol li.ql-indent-2:before {
    content: counter(list-2, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-3 {
    counter-increment: list-3;
  }
  .ql-editor ol li.ql-indent-3:before {
    content: counter(list-3, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-4 {
    counter-increment: list-4;
  }
  .ql-editor ol li.ql-indent-4:before {
    content: counter(list-4, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-5 {
    counter-increment: list-5;
  }
  .ql-editor ol li.ql-indent-5:before {
    content: counter(list-5, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-6 {
    counter-increment: list-6;
  }
  .ql-editor ol li.ql-indent-6:before {
    content: counter(list-6, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-7 {
    counter-increment: list-7;
  }
  .ql-editor ol li.ql-indent-7:before {
    content: counter(list-7, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-7 {
    counter-reset: list-8 list-9;
  }
  .ql-editor ol li.ql-indent-8 {
    counter-increment: list-8;
  }
  .ql-editor ol li.ql-indent-8:before {
    content: counter(list-8, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-8 {
    counter-reset: list-9;
  }
  .ql-editor ol li.ql-indent-9 {
    counter-increment: list-9;
  }
  .ql-editor ol li.ql-indent-9:before {
    content: counter(list-9, decimal) '. ';
  }
  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 4.5em;
  }
  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3em;
  }
  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 4.5em;
  }
  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }
  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 7.5em;
  }
  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 6em;
  }
  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 7.5em;
  }
  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }
  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 10.5em;
  }
  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 9em;
  }
  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 10.5em;
  }
  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em;
  }
  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 13.5em;
  }
  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 12em;
  }
  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 13.5em;
  }
  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em;
  }
  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 16.5em;
  }
  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 15em;
  }
  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 16.5em;
  }
  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em;
  }
  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 19.5em;
  }
  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 18em;
  }
  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 19.5em;
  }
  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em;
  }
  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 22.5em;
  }
  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 21em;
  }
  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 22.5em;
  }
  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em;
  }
  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 25.5em;
  }
  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 24em;
  }
  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 25.5em;
  }
  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 27em;
  }
  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 28.5em;
  }
  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 27em;
  }
  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 28.5em;
  }
  .ql-editor .ql-video {
    display: block;
    max-width: 100%;
  }
  .ql-editor .ql-video.ql-align-center {
    margin: 0 auto;
  }
  .ql-editor .ql-video.ql-align-right {
    margin: 0 0 0 auto;
  }
  .ql-editor .ql-bg-black {
    background-color: #000;
  }
  .ql-editor .ql-bg-red {
    background-color: #e60000;
  }
  .ql-editor .ql-bg-orange {
    background-color: #f90;
  }
  .ql-editor .ql-bg-yellow {
    background-color: #ff0;
  }
  .ql-editor .ql-bg-green {
    background-color: #008a00;
  }
  .ql-editor .ql-bg-blue {
    background-color: #06c;
  }
  .ql-editor .ql-bg-purple {
    background-color: #93f;
  }
  .ql-editor .ql-color-white {
    color: #fff;
  }
  .ql-editor .ql-color-red {
    color: #e60000;
  }
  .ql-editor .ql-color-orange {
    color: #f90;
  }
  .ql-editor .ql-color-yellow {
    color: #ff0;
  }
  .ql-editor .ql-color-green {
    color: #008a00;
  }
  .ql-editor .ql-color-blue {
    color: #06c;
  }
  .ql-editor .ql-color-purple {
    color: #93f;
  }
  .ql-editor .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-editor .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-editor .ql-size-small {
    font-size: 0.75em;
  }
  .ql-editor .ql-size-large {
    font-size: 1.5em;
  }
  .ql-editor .ql-size-huge {
    font-size: 2.5em;
  }
  .ql-editor .ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
  }
  .ql-editor .ql-align-center {
    text-align: center;
  }
  .ql-editor .ql-align-justify {
    text-align: justify;
  }
  .ql-editor .ql-align-right {
    text-align: right;
  }
  .ql-editor.ql-blank::before {
    color: rgba(0, 0, 0, 0.6);
    content: attr(data-placeholder);
    font-style: italic;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
  }
</style>
